import Cookies from 'js-cookie';

export const setCookie = (name, value, options = {}) =>
  Cookies.set(name, value, { expires: 7, secure: true, ...options });

export const removeCookie = (name) => Cookies.remove(name);

// when name not provided - return all cookies
export const getCookie = (name = null) => (!!name ? Cookies.get(name) : Cookies.get());
